module.exports = __webpack_public_path__ + "static/media/logo-ministere.9baef279.png";